import {
  Circle,
  Folder,
  Database,
  Table,
  File,
  FilePlus,
  FolderPlus,
  Server,
  Key,
  Plus,
  MoreHorizontal,
  Link2,
  Zap,
  ListOrdered,
  Layers,
  ShieldCheck,
  RefreshCw,
  Trash2,
  Eraser,
  Pencil,
  Plug,
  Unplug,
  Eye,
  Code,
  Lock,
  Download,
  Upload,
  AlertTriangle,
  LoaderCircle,
  Copy,
  LayoutList,
  Network,
} from 'lucide-react';
import { DbBrandIcon } from '../dbBrandIcons';

// Thin adapters so a db-manager brand icon name (sent as a plain string like
// any other TreeNode.icon) can drop into the same <Icon size className>
// call sites lucide components use. Same glyphs as the New Connection
// modal's engine picker (ExtensionModalHost's OptionIcon), but rendered
// solid white and a couple px larger than the row's other 12px icons so the
// brand mark actually reads at sidebar scale instead of accent-on-accent.
function brandIcon(name) {
  return function BrandTreeIcon({ size, className }) {
    return (
      <DbBrandIcon
        name={name}
        size={(size || 12) + 3}
        color="#fff"
        className={className}
        style={{ marginRight: '9px' }}
      />
    );
  };
}

// Closed allowlist — TreeNode.icon / action.icon are lucide-react names, never
// arbitrary SVG/HTML, so an extension can't inject markup into the host tree.
export const ICONS = {
  folder: Folder,
  database: Database,
  table: Table,
  file: File,
  'file-plus': FilePlus,
  'folder-plus': FolderPlus,
  server: Server,
  key: Key,
  plus: Plus,
  link: Link2,
  zap: Zap,
  list: ListOrdered,
  layers: Layers,
  shield: ShieldCheck,
  refresh: RefreshCw,
  trash: Trash2,
  eraser: Eraser,
  copy: Copy,
  edit: Pencil,
  plug: Plug,
  unplug: Unplug,
  eye: Eye,
  code: Code,
  lock: Lock,
  download: Download,
  upload: Upload,
  'alert-triangle': AlertTriangle,
  loader: LoaderCircle,
  overview: LayoutList,
  diagram: Network,
  'db-mysql': brandIcon('mysql'),
  'db-postgres': brandIcon('postgres'),
  'db-sqlite': brandIcon('sqlite'),
};

export function resolveIcon(name) {
  return ICONS[name] || Circle;
}

export function resolveActionIcon(name) {
  return ICONS[name] || MoreHorizontal;
}
